import { MongoObjectIdSchema } from '@terra/shared-utils';
import { z } from 'zod';

export const CreateExternalNetworkFindingChainBodySchema = z.object({
  externalNetworkId: MongoObjectIdSchema,
  findingIds: z.array(MongoObjectIdSchema).min(2).max(32),
});

export const CreateExternalNetworkFindingChainResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  signalId: z.string().optional(),
  alreadyExisted: z.boolean().optional(),
});

export type CreateExternalNetworkFindingChainBodyDto = z.infer<
  typeof CreateExternalNetworkFindingChainBodySchema
>;

export type CreateExternalNetworkFindingChainResponseDto = z.infer<
  typeof CreateExternalNetworkFindingChainResponseSchema
>;
